export function toolForPath(path: string): string {
  if (/^\/monitor(?:\/|$)/.test(path)) return 'monitor';
  if (/^\/measure-model(?:\/|$)/.test(path) || path === '/new-project') return 'measure_model';
  if (/^\/asset-manager(?:\/|$)/.test(path)) return 'manage';
  if (/^\/customers(?:\/|$)/.test(path)) return 'customers';
  if (/^\/dealers(?:\/|$)/.test(path)) return 'dealers';
  if (path === '/' || /^\/(dashboard|new-dashboard)(?:\/|$)/.test(path)) return 'dashboard';
  if (/^\/admin(?:\/|$)/.test(path)) return 'admin';
  return 'other';
}
export function contextForPath(path: string) {
  const project = path.match(/^\/(monitor|measure-model)\/(\+?\d+)(?:\/|$)/);
  const client = path.match(/^\/(customers|dealers)\/(\d+)(?:\/|$)/);
  return { tool: toolForPath(path), ...(project ? { project_id: Number(project[2]) } : {}), ...(client ? { client_id: Number(client[2]) } : {}) };
}
export function compareTools(current: Record<string, string | number>[], previous: Record<string, string | number>[]) {
  const sum = (rows: Record<string, string | number>[]) => rows.reduce<Record<string, number>>((result, row) => {
    const tool = toolForPath(String(row.pagePath));
    result[tool] = (result[tool] || 0) + Number(row.userEngagementDuration || 0);
    return result;
  }, {});
  const now = sum(current), before = sum(previous);
  const total = Object.values(now).reduce((a, b) => a + b, 0);
  return [...new Set([...Object.keys(now), ...Object.keys(before)])].map((tool) => ({
    tool, current: now[tool] || 0, previous: before[tool] || 0,
    delta: (now[tool] || 0) - (before[tool] || 0),
    percent: before[tool] ? (((now[tool] || 0) - before[tool]) / before[tool]) * 100 : null,
    share: total ? ((now[tool] || 0) / total) * 100 : 0,
  })).sort((a, b) => b.current - a.current);
}

/** Keep sub-minute engagement and signed changes legible without decimal hours. */
export function formatUsageDuration(seconds: number): string {
  if (!Number.isFinite(seconds)) return '—';
  const absolute = Math.abs(seconds);
  const sign = seconds < 0 ? '−' : '';
  if (absolute > 0 && absolute < 1) return `${sign}<1 s`;
  const rounded = Math.round(absolute);
  const h = Math.floor(rounded / 3600);
  const m = Math.floor(rounded % 3600 / 60);
  const s = rounded % 60;
  return sign + [h && `${h} h`, m && `${m} min`, (s || (!h && !m)) && `${s} s`].filter(Boolean).join(' ');
}
